import { getEmployees_service } from "@Services/employee/GetEmployees.service";
import { capitalizeWords } from "@Utilities/CapitalizeWords";

interface Employee {
  name: string;
  lastName: string;
  idEmployee: number;
}

export const getEmployees_adapter = async () => {
  const response = await getEmployees_service();
  if (!response.isSuccess) {
    return response;
  }

  // Ya no filtramos por rol, traemos todos los empleados
  const employeesAdapted: Employee[] = response.data.map((employee: any) => ({
    name: capitalizeWords(employee.name),
    lastName: capitalizeWords(employee.lastName),
    idEmployee: employee.idEmployee,
  }));

  return {
    ...response,
    data: employeesAdapted,
    message: response.message,
    status: response.status,
  };
};
